import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { Main } from "../../../../../../themes/Default/components/Main";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { useTranslation } from "react-i18next";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { legalEntityManagement } from "../../../../../../hooks/api/LegalEntitiesManagement/LegalEntitiesManagement";

const EditLegalEntity = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { legalEntityId } = useParams();
    const [formErrors, setFormErrors] = useState([]);
    const { useViewLegalEntityMutation, useUpdateLegalEntityMutation} = legalEntityManagement;
    const [updateLegalEntity] = useUpdateLegalEntityMutation();
    const [viewLegalEntity] = useViewLegalEntityMutation();

    const tabs = [
        { title: t("locations.title"), onClick: () => gotoLocationTab() },
        { title: t("legalEntity.title"),isActive: true  },
    ];

    const gotoLocationTab = () => {
        navigate("/settings/locations/locations");
    }

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        updateLegalEntity({body, legalEntityId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/locations/legal-entities");
                toast.info(result?.data?.info?.responseMessage);
            }
        });
    };

    useEffect(() => {
        viewLegalEntity(legalEntityId).then((result) => {
            formRef.current.setValues(result?.data);
            console.log(result?.data);
        });

    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/locations/legal-entities" />
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
            <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("locations.title")} />
                    <Link title={t("legalEntity.title")} />
                    <Link title={t("legalEntity.edit")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        name: "",
                        address: "",
                        accountNumber: ""
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="name"
                                        label={t("locations.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                    />
                                </Field>
                                <Field>
                                    <Input
                                        name="address"
                                        label={t("locations.address")}
                                        required={true}
                                        value={values.address}
                                        onChange={handleChange}
                                        error={formErrors?.address}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Input
                                        name="accountNumber"
                                        label={t("legalEntity.accountNumber")}
                                        required={true}
                                        value={values.accountNumber}
                                        onChange={handleChange}
                                        error={formErrors?.accountNumber}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditLegalEntity;
